//课程直播列表功能
import request from './request'

//获取单条专辑的信息
export function _topicSingleinfo(data = {}) {
    const config = Object.assign(data, {
      method: 'get',
      url: '/admin/topic/getinfo',
    })
    return request(config)
  }

//专题上架
export function _topicOnline(data = {}) {
    const config = Object.assign(data, {
      method: 'get',
      url: '/admin/topic/online',
    })
    return request(config)
}

//专题下架
export function _topicOffline(data = {}) {
    const config = Object.assign(data, {
      method: 'get',
      url: '/admin/topic/offline',
    })
    return request(config)
}

// 专题删除
export function _topicDel(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/topic/del',
  })
  return request(config)
}

//专题创建
export function _topicAdd(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/topic/add',
  })
  return request(config)
}

//专题列表
export function _getTopicList(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/topic/index',
  })
  return request(config)
}

//专题编辑
export function _topicEdit(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/topic/edit',
  })
  return request(config)
}

//专题分享的接口
export function _topicShare(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/xcx/topic',
  })
  return request(config)
}

//专题添加课程
export function _topicAddLinks(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/topic/add-links',
  })
  return request(config)
}